// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__91-oY","dialogContent":"Dialog_dialogContent__lDuLR","closeBtn":"Dialog_closeBtn__gSku7"};